import { useAuthStore } from '@sentinel/web-core';
import { RouterProvider } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { BootScreen } from '@/shell/BootScreen';
import { Providers } from './providers';
import { router } from './router';

/** Console root: restores the session of this host, then mounts the router. */
export function App() {
  const [ready, setReady] = useState(false);
  const bootstrap = useAuthStore((s) => s.bootstrap);

  useEffect(() => {
    void bootstrap().finally(() => setReady(true));
  }, [bootstrap]);

  return <Providers>{ready ? <RouterProvider router={router} /> : <BootScreen />}</Providers>;
}
